import React, { useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'js/components';

import styles from './CustomizeAssessment.module.scss';

function StatusBadge({ userGroupAssessment }) {
  const [reevaluateCounter, setReevaluateCounter] = useState(1);
  const goingLive = useMemo(() => {
    const now = new Date();

    return (
      reevaluateCounter > 0 &&
      userGroupAssessment.status === 'published' &&
      userGroupAssessment.go_live_at <= now
    );
  }, [userGroupAssessment.status, userGroupAssessment.go_live_at, reevaluateCounter]);

  useEffect(() => {
    if (
      userGroupAssessment.status === 'published' &&
      userGroupAssessment.go_live_at
    ) {
      const goLiveDate = new Date(userGroupAssessment.go_live_at);
      const now = new Date();

      if (goLiveDate > now) {
        // Set timeout to update status when go_live_at is reached
        const timeUntilGoLive = goLiveDate.getTime() - now.getTime();
        const timeoutId = setTimeout(() => {
          setReevaluateCounter(reevaluateCounter + 1);
        }, timeUntilGoLive);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [userGroupAssessment.status, userGroupAssessment.go_live_at, reevaluateCounter]);

  return (
    <div
      className={classNames(
        styles['status-badge'],
        styles[userGroupAssessment.status]
      )}
    >
      {goingLive ? (
        <>
          Going live
          <Icon icon={faCircleNotch} spin className="icon-right" />
        </>
      ) : (
        userGroupAssessment.status
      )}
    </div>
  );
}

export default StatusBadge;
